export default "__VITE_ASSET__BxrV8HM6__"